// Sticky add-to-cart bar: mirrors the section's subscription selector (one-time/subscribe
// mode and checked option, matched by index) and appears once the selector scrolls above
// the viewport. In dynamic mode it submits its own `product-form` (AJAX + cart drawer);
// in static mode the CTA is a link whose href follows the selected option and mode.
if (!window.customElements.get('sticky-add-to-cart')) {
  window.customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends window.HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-sticky-select]');
        this.labelEl = this.querySelector('[data-sticky-label]');
        this.cta = this.querySelector('[data-sticky-cta]');
        this.ctaTotal = this.querySelector('[data-sticky-cta-total]');
        this.ctaCompare = this.querySelector('[data-sticky-cta-compare]');
        this.variantInput = this.querySelector('input[name="id"]');
        this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');

        const sectionEl = this.closest('.shopify-section');
        this.selector = (sectionEl || document).querySelector(
          'subscription-selector-dynamic, subscription-selector',
        );

        this.select?.addEventListener('change', () => this.syncToSelector());

        if (!this.selector) return;

        this.radios = [...this.selector.querySelectorAll('input[type="radio"]')];

        this.onSelectorChange = (event) => {
          if (event.target.matches('input[type="radio"]')) this.syncFromSelector();
        };
        this.selector.addEventListener('change', this.onSelectorChange);

        this.modeObserver = new MutationObserver(() => this.render());
        this.modeObserver.observe(this.selector, { attributes: true, attributeFilter: ['class'] });

        this.initVisibilityObserver();
        this.syncFromSelector();
      }

      disconnectedCallback() {
        this.selector?.removeEventListener('change', this.onSelectorChange);
        this.modeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }

      get isOneTime() {
        return this.selector
          ? this.selector.classList.contains('is-one-time')
          : this.dataset.startMode === 'one-time';
      }

      initVisibilityObserver() {
        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.add('is-hidden');
              } else if (this.selector.getBoundingClientRect().top < 0) {
                this.classList.remove('is-hidden');
              }
            });
          },
          { threshold: 0.1, rootMargin: '0px 0px -50px 0px' },
        );

        this.visibilityObserver.observe(this.selector);
      }

      syncFromSelector() {
        const index = this.radios.findIndex((radio) => radio.checked);
        if (index >= 0 && this.select && this.select.selectedIndex !== index) {
          this.select.selectedIndex = index;
        }
        this.render();
      }

      syncToSelector() {
        const radio = this.radios?.[this.select.selectedIndex];
        if (radio && !radio.checked) {
          radio.checked = true;
          // Non-bubbling so our own delegated listener on the selector doesn't re-enter.
          radio.dispatchEvent(new Event('change', { bubbles: false }));
        }
        this.render();
      }

      render() {
        if (!this.select || this.select.options.length === 0) return;

        const option = this.select.options[this.select.selectedIndex] || this.select.options[0];
        const data = option.dataset;
        const p = this.isOneTime ? 'one' : 'sub';

        if (this.labelEl) this.labelEl.textContent = option.textContent.trim();
        this.setText(this.ctaTotal, data[`${p}Total`]);
        this.setText(this.ctaCompare, data[`${p}CompareTotal`]);

        if (this.dataset.mode === 'static') {
          if (this.cta) this.cta.href = data[`${p}Url`] || '#';
          return;
        }

        if (this.variantInput) this.variantInput.value = option.value;
        if (this.sellingPlanInput) {
          const planId = data.sellingPlanId || '';
          this.sellingPlanInput.value = planId;
          this.sellingPlanInput.disabled = this.isOneTime || planId === '';
        }
        if (this.cta) this.cta.disabled = data.available === 'false';
      }

      setText(el, value) {
        if (!el) return;
        el.textContent = value || '';
        el.classList.toggle('is-hidden', !value);
      }
    },
  );
}
